<template>
  <div>
    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown"
      title="Integração Suporte POS" id="integracao-suportepos-status-button" aria-haspopup="true"
      aria-expanded="false">
      SuportPOS
    </button>

    <div class="dropdown-menu" aria-labelledby="integracao-suportepos-status-button">
      <a class="dropdown-item" href="#" @click="abrirModalRecepcao()"> Pagar </a>
      <!-- <a class="dropdown-item" href="#" @click="abrirModalCartao()"> Pagar com cartão </a> -->
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" href="#" @click="cancelarPagamento()">
        Cancelar pagamento
      </a>
      <a class="dropdown-item" href="#" @click="logComunicacao()">
        <i class="fa-solid fa-book fa-fw mr-2"></i>Log de Comunicação</a>
    </div>

    <log-integracao ref="logInt" />
    
    <div class="modal fade" id="modalRecepcao" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <span>Escolha a recepção</span>
            <button type="button" class="close" @click="fecharModalRecepcao()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" style="display: flex; justify-content: space-between; flex-direction: column;">
              <table style=" border-collapse: separate; border-spacing: 15px">
                <thead>
                  <tr>
                    <td>
                      Recepção
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <select class="form form-control" v-model="id_recepcao">
                        <option value="">Selecione uma recepção</option>
                        <option v-for="recepcao in recepcoes_disponiveis" :key="recepcao.id_configuracao_pagamento_ec"
                          :value="recepcao.id_recepcao">
                          {{ recepcao.st_nome_ec }}
                        </option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" style="float: right" @click="pagar()">
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import LogIntegracao from "../shared/audit/LogIntegracao.vue";

export default {
  data() {
    return {
      id_recepcao: null,
      recepcoes_disponiveis: [],
    };
  },

  props: {
    id_pagamento_atendimento: {
      type: Number,
      required: true,
    },
    marcacao: {
      type: Object,
      required: false,
    },
    id_unidade_operacao: {
      type: Number,
      required: false,
    },
  },

  components: {
    LogIntegracao
  },

  methods: {
    abrirModalRecepcao() {
      $("#modalRecepcao").modal("show");
    },

    fecharModalRecepcao() {
      $("#modalRecepcao").modal("hide");
    },

    abrirModalCartao() {
      $("#modalCartao").modal("show");
    },

    fecharModalCartao() {
      $("#modalCartao").modal("hide");
    },

    cancelarPagamento: function () {
      this.$util.atualizar(this, {
        service: "atendimentos",
        func: "suportpos_cancelar_pagamento",
        dados: {
          id_pagamento_atendimento: this.id_pagamento_atendimento,
        },
        callback: (res) => {
          if (!res.ok) {
            this.$toast.add({
              severity: "error",
              summary: "Aguarde",
              detail: res.body,
              life: 6000,
            });
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Aguarde",
              detail: res.body,
              life: 6000,
            });
          }
        },
      });
    },

    pagar() {
      this.$util.atualizar(this, {
        service: "atendimentos",
        func: "suportpos_pagar_pagamento",
        dados: {
          id_pagamento_atendimento: this.id_pagamento_atendimento,
          id_recepcao: this.id_recepcao,
        },
        callback: (res) => {
          if (!res.ok) {
            this.$toast.add({
              severity: "error",
              summary: "Sucesso",
              detail: res.body,
              life: 6000,
            });
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: res.body,
              life: 6000,
            });
          }
          this.fecharModalRecepcao();
        },
      });
    },

    logComunicacao: function () {
      this.$refs.logInt.abrir("pagamentoAtendimento", this.id_pagamento_atendimento, true);
    },

    getRecepcoes() {
      this.$util.load(this, {
        service: "recepcoes_ecs",
        func: "listar_recepcoes_ecs",
        parms: {
          id_recepcao: this.marcacao ? this.marcacao.id_recepcao : null,
          id_unidade_operacao: this.id_unidade_operacao
        },
        loadTo: (res) => {
          this.recepcoes_disponiveis = res;
        },
      });
    },
  },

  mounted() {
    this.getRecepcoes();
  },
};
</script>
<style>
#cartaoModal {
  z-index: 99999;
}

.custom-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}
</style>
